import React from "react";
import { Box, Typography } from "@mui/material";
import { SelectedCheckIcon } from "./onboardingIcons";

const GREEN = "rgb(20, 107, 68)";

/**
 * Onboarding card selector: real <button>s (keyboard + screen-reader friendly),
 * optional icon above the label, selected state marked by color AND a check
 * badge. 2 columns on mobile, one row on desktop.
 */
const IconCardSelect = ({ fieldName, selected, values, onChange, multiple = false }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: {
        xs: "1fr 1fr",
        md: `repeat(${Math.min(values.length, 5)}, 1fr)`,
      },
      gap: "0.75rem",
    }}
  >
    {values.map(({ code, label, icon: Icon }) => {
      const isSelected = multiple ? (selected || []).includes(code) : selected === code;
      return (
        <Box
          key={String(code)}
          component="button"
          type="button"
          onClick={() => onChange(fieldName, code, multiple)}
          aria-pressed={isSelected}
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: Icon ? "0.5rem" : 0,
            minHeight: Icon ? "88px" : "56px",
            p: "0.75rem 0.5rem",
            borderRadius: "0.75rem",
            cursor: "pointer",
            border: `1px solid ${isSelected ? GREEN : "hsl(220, 13%, 71%)"}`,
            bgcolor: isSelected ? GREEN : "hsl(0, 0%, 100%)",
            color: isSelected ? "hsl(0, 0%, 100%)" : "hsl(222.2, 84%, 4.9%)",
            transition: "border-color 0.15s, background-color 0.15s, color 0.15s",
            "&:hover": { borderColor: GREEN },
          }}
        >
          {Icon && <Icon size={26} />}
          <Typography
            sx={{
              fontSize: "0.8125rem",
              fontFamily: "'Segoe UI Semibold', system-ui, sans-serif",
              lineHeight: 1.25,
              textAlign: "center",
              color: "inherit",
            }}
          >
            {label}
          </Typography>
          {isSelected && (
            <Box
              sx={{
                position: "absolute",
                top: "6px",
                right: "6px",
                width: 18,
                height: 18,
                borderRadius: "50%",
                bgcolor: "hsl(0, 0%, 100%)",
                color: GREEN,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <SelectedCheckIcon size={11} />
            </Box>
          )}
        </Box>
      );
    })}
  </Box>
);

export default IconCardSelect;
